/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TooltipModule, TooltipOptions } from 'ng2-tooltip-directive';

import { RefreshModule } from '../../refresh/refresh.module';


import {TranslateModule, TranslateLoader} from "@ngx-translate/core";
import { HttpTranslateLoader } from '../../refresh/service/translate-loader';

import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from "@angular/common/http";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { environment } from '../../environments/environment';

import { ProgressBarComponent } from '../_common/progress_bar/progress_bar.component';

import { ErrorComponent } from '../error/error.component';
import { ORGContactInformationComponent } from '../ORG_contact_information/ORG_contact_information.component';
import { FAQComponent } from '../FAQ/FAQ.component';
//import { AdditionalInfoComponent } from '../additional_info/additional_info.component';
///import { ReceiptComponent } from '../receipt/receipt.component';
import { ProvincialPaymentComponent } from '../provincial_payment/provincial_payment.component';
import { NextRegistrationComponent } from '../next_registration/next_registration.component';
import { OrderSummaryComponent } from '../order_summary/order_summary.component';
import { ESRAreYouSureComponent } from '../ESR_are_you_sure/ESR_are_you_sure.component';
import { ESRMainComponent } from '../ESR_main/ESR_main.component';
import { SINAreYouSureComponent } from '../SIN_are_you_sure/SIN_are_you_sure.component';
import { SINMainComponent } from '../SIN_main/SIN_main.component';
import { CCBAreYouSureComponent } from '../CCB_are_you_sure/CCB_are_you_sure.component';
import { CCBMainComponent } from '../CCB_main/CCB_main.component';
import { Transition2Component } from '../transition_2/transition_2.component';
import { BirthCertificateAreYouSureComponent } from '../birth_certificate_are_you_sure/birth_certificate_are_you_sure.component';
import { BirthCertificateComponent } from '../birth_certificate/birth_certificate.component';
import { Transition1Component } from '../transition_1/transition_1.component';
import { FinalReviewComponent } from '../final_review/final_review.component';
import { ContactInfoAndMailingAddressComponent } from '../contact_info_and_mailing_address/contact_info_and_mailing_address.component';
import { AboutTheParentsScreen1Component } from '../about_the_parents_screen/about_the_parents_screen_1.component';
import { AboutTheParentsScreen2Component } from '../about_the_parents_screen/about_the_parents_screen_2.component';
import { AboutTheParentsScreen3Component } from '../about_the_parents_screen/about_the_parents_screen_3.component';
import { AboutTheParentsScreen4Component } from '../about_the_parents_screen/about_the_parents_screen_4.component';
import { AboutTheParentsMainComponent } from '../about_the_parents_main/about_the_parents_main.component';
import { AboutTheChildScreen2Component } from '../about_the_child_screen_2/about_the_child_screen_2.component';
import { AboutTheChildMainComponent } from '../about_the_child_main/about_the_child_main.component';
import { Setup5Component } from '../setup_5/setup_5.component';
import { Setup4Component } from '../setup_4/setup_4.component';
import { Setup3Component } from '../setup_3/setup_3.component';
import { Setup2Component } from '../setup_2/setup_2.component';
import { Setup1Component } from '../setup_1/setup_1.component';
import { BeforeYouBeginComponent } from '../before_you_begin/before_you_begin.component';
import { StartComponent } from '../start/start.component';
import { CanadaAddressComponent } from '../contact_info_and_mailing_address/canada-address/canada-address.component';
import { InternationalAddressComponent } from '../contact_info_and_mailing_address/international-address/international-address.component';
import { BirthdayComponent } from '../setup_1/birth-day/birth-day.component';
import { ChildDeceasedComponent } from '../setup_2/child-deceased/child-deceased.component';
import { AddtionalDocComponent } from '../setup_4/addtional-doc/addtional-doc.component';

import { ProgressMenuComponent } from '../_common/progress_menu/progress_menu.component';
import { NoCacheHeadersInterceptor } from 'src/refresh/service/NoCacheHeadersInterceptor';
import { RecaptchaModule } from 'ng-recaptcha';

export function HttpLoaderFactory(httpClient: HttpClient) {
      if ( environment.production ) {
            return new HttpTranslateLoader(httpClient,true,["./assets/i18n/all"]);
      }
      else {
            return new HttpTranslateLoader(httpClient,false,[
                                                  "./assets/i18n/.footer/footer",
                                                  "./assets/i18n/.ORG_contact_information/ORG_contact_information",
                                                  "./assets/i18n/.FAQ/FAQ",
                                                  "./assets/i18n/.provincial_payment/provincial_payment",
                                                  "./assets/i18n/.next_registration/next_registration",
                                                  "./assets/i18n/.order_summary/order_summary",
                                                  "./assets/i18n/.ESR_are_you_sure/ESR_are_you_sure",
                                                  "./assets/i18n/.ESR_main/ESR_main",
                                                  "./assets/i18n/.SIN_are_you_sure/SIN_are_you_sure",
                                                  "./assets/i18n/.SIN_main/SIN_main",
                                                  "./assets/i18n/.CCB_are_you_sure/CCB_are_you_sure",
                                                  "./assets/i18n/.CCB_main/CCB_main",
                                                  "./assets/i18n/.transition_2/transition_2",
                                                  "./assets/i18n/.birth_certificate_are_you_sure/birth_certificate_are_you_sure",
                                                  "./assets/i18n/.birth_certificate/birth_certificate",
                                                  "./assets/i18n/.transition_1/transition_1",
                                                  "./assets/i18n/.final_review/final_review",
                                                  "./assets/i18n/.contact_info_and_mailing_address/contact_info_and_mailing_address",
                                                  "./assets/i18n/.about_the_parents_screen/about_the_parents_screen",
                                                  "./assets/i18n/.about_the_parents_main/about_the_parents_main",
                                                  "./assets/i18n/.about_the_child_screen_2/about_the_child_screen_2",
                                                  "./assets/i18n/.about_the_child_main/about_the_child_main",
                                                  "./assets/i18n/.setup_5/setup_5",
                                                  "./assets/i18n/.setup_4/setup_4",
                                                  "./assets/i18n/.setup_3/setup_3",
                                                  "./assets/i18n/.setup_2/setup_2",
                                                  "./assets/i18n/.setup_1/setup_1",
                                                  "./assets/i18n/.before_you_begin/before_you_begin",
                                                  "./assets/i18n/.start/start",
                                                  "./assets/i18n/.error/error",
                                                  "./assets/i18n/project/project",
                                                  "./assets/i18n/project/pages"
                                                 ]);
      }
}

export const MyDefaultTooltipOptions: TooltipOptions = {
      'placement': 'left',
      'tooltip-class': 'alt-text',
      'show-delay': 500,
      'max-width':350,
      'animation-duration':10
}

@NgModule({
  declarations: [

    ProgressBarComponent,

    AppComponent,
    ProgressMenuComponent,
    ErrorComponent,
    ORGContactInformationComponent,
    FAQComponent,
    ProvincialPaymentComponent,
    NextRegistrationComponent,
    OrderSummaryComponent,
    ESRAreYouSureComponent,
    ESRMainComponent,
    SINAreYouSureComponent,
    SINMainComponent,
    CCBAreYouSureComponent,
    CCBMainComponent,
    Transition2Component,
    BirthCertificateAreYouSureComponent,
    BirthCertificateComponent,
    Transition1Component,
    FinalReviewComponent,
    ContactInfoAndMailingAddressComponent,
    AboutTheParentsScreen4Component,
    AboutTheParentsScreen3Component,
    AboutTheParentsScreen2Component,
    AboutTheParentsScreen1Component,
    AboutTheParentsMainComponent,
    AboutTheChildScreen2Component,
    AboutTheChildMainComponent,
    Setup5Component,
    Setup4Component,
    Setup3Component,
    Setup2Component,
    Setup1Component,
    BeforeYouBeginComponent,
    StartComponent,
    CanadaAddressComponent,
    InternationalAddressComponent,
    BirthdayComponent,
    ChildDeceasedComponent,
    AddtionalDocComponent
  ],
  imports: [
    BrowserModule,
    TooltipModule.forRoot(MyDefaultTooltipOptions as TooltipOptions) ,
    RefreshModule,
    AppRoutingModule,
    HttpClientModule,
    RecaptchaModule,
    
    TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })  
    
    ],
  providers: [{ provide: HTTP_INTERCEPTORS,
                useClass: NoCacheHeadersInterceptor,
                multi: true
              }],  
  bootstrap: [AppComponent]
})
export class AppModule { }
